import { createFileRoute, redirect } from "@tanstack/react-router";

/** The address sent in "your form is ready" emails before Move-in packets had tabs. */
export const Route = createFileRoute(
  "/_authenticated/_administration/settings/admission-form-availability",
)({
  beforeLoad: () => {
    throw redirect({ to: "/settings/move-in/forms", replace: true });
  },
});
